import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/site";

export default function Logo({ className = "", imgClass = "h-8", showWordmark = false }) {
  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      className={`inline-flex items-center gap-2 ${className}`}
      aria-label="StUpEco Workspace home"
    >
      <img src={LOGO_URL} alt="StUpEco Workspace" className={`${imgClass} w-auto`} />
      {showWordmark && (
        <span className="text-sm font-semibold tracking-tight text-muted-foreground">Workspace</span>
      )}
    </Link>
  );
}
